import { Theme } from "@mui/material/styles";
import { theme as defaultTheme } from "@answersnow/pkg-theme";

import type { Status as StatusId } from "api/types/aba";

interface StatusStyleConfig {
  bgcolor: string;
  dotColor: string;
  textColor: string;
}

/**
 * Returns a mapping of status IDs to their corresponding style configurations.
 * The styles are derived from the MUI theme, with fallbacks to hardcoded colors.
 */
function getStatusStyles(theme: Theme = defaultTheme): Record<StatusId, StatusStyleConfig> {
  // Cast to any to access extended palette colors from @answersnow/pkg-theme
  const p = theme.palette as any;

  return {
    "in-progress": {
      bgcolor: p.success?.background ?? "#e8f5e9",
      dotColor: theme.palette.success.light,
      textColor: theme.palette.success.light,
    },
    "not-active": {
      bgcolor: p.grayscale?.[50] ?? "#f6f7f8",
      dotColor: theme.palette.text.secondary,
      textColor: theme.palette.text.secondary,
    },
    discontinued: {
      bgcolor: p.error?.background ?? "#feebee",
      dotColor: theme.palette.error.main,
      textColor: theme.palette.error.main,
    },
    met: {
      bgcolor: p.blue?.[50] ?? "#e3f2fd",
      dotColor: p.blue?.[500] ?? "#2196f3",
      textColor: p.blue?.[500] ?? "#2196f3",
    },
    "on-hold": {
      bgcolor: p.warning?.background ?? "#fff3e0",
      dotColor: theme.palette.warning.main,
      textColor: theme.palette.warning.main,
    },
    archived: {
      bgcolor: p.grayscale?.[50] ?? "#f6f7f8",
      dotColor: theme.palette.text.secondary,
      textColor: theme.palette.text.secondary,
    },
  };
}

export default getStatusStyles;
